import { render, staticRenderFns } from "./SalesByDayModal.vue?vue&type=template&id=6d3524a6"
import script from "./SalesByDayModal.vue?vue&type=script&lang=js"
export * from "./SalesByDayModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports